import { useCallback, useEffect, useState, useMemo } from "react";
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { openPdfResponse } from "../../utils/openPdfInApp";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import ListFormPageHeader from "../../components/ListFormPageHeader";
import Sidebar from '../../Sidebar';
import { useCookies } from 'react-cookie';
import { getAllInvoices,printSalesInvoice } from "../../services/SalesInvoiceServices";
import { getListViewSettings } from "../../services/SettingsServices";
import { buildSalesInvoiceQueryParams } from "../../utils/listViewDateRanges";
import { displayError } from "../../helpers";

function SalesInvoiceTable() {
    const InitialData = {
        records: []
    };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true);

    const columns = useMemo(
        () => [
            {
                fieldName: 'plant_alias', 
                headerName: 'Plant'
            },
            {
                fieldName: "doc_type",
                headerName: 'Doc Type'
            },
            {
                fieldName: "invoice_no",
                headerName: 'Invoice Number'
            },
            {
                fieldName: "invoice_date",
                headerName: 'Invoice Date'
            },
            {
                fieldName: "customer_name",
                headerName: 'Customer Name'
            },
            {
                fieldName: "project_name",
                headerName: 'Site Name'
            },
            {
                fieldName: "invoice_amt",
                headerName: 'Invoice Amount'
            },
            {
                fieldName: 'salesrep_name', 
                headerName: 'Marketting'
            },
            {
                fieldName: "einvoice_status",
                headerName: 'E-Invoice Status'
            },
            {
                fieldName: "einvoice_irn",
                headerName: 'IRN'
            },
            {
                fieldName: "status",
                headerName: 'Status'
            },
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
        ],
        [],);
    
    const onEditSalesPosting = (salespostId, event) => {
        const selected_invoice = data.records.filter(obj=>obj.id === salespostId)
        console.log(JSON.stringify(selected_invoice)+"selected_invoice");
        if(selected_invoice[0].remarks === 'sales_invoice'){
            navigate(`/SalesInvoiceEdit/${salespostId}/`);
        }
        else{
            navigate(`/DirectInvoiceEdit/${salespostId}/`);
        }
    };

    const onPrintSalesPosting = (salespostId, event) => {
        event.preventDefault();
        setIsLoading(true);
        printSalesInvoice(cookies, salespostId)
        .then(response => {
            openPdfResponse(response, {
                title: 'Sales Invoice',
                downloadFileName: 'sales_invoice.pdf',
            });
            setIsLoading(false);
        })
        .catch(error => {
            // setRefreshKey(oldKey => oldKey +1);
            console.log(error);
            displayError(error,'Print Failed');
            setIsLoading(false);
        });  
    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(invoice => {
                const csvRow ={
                    plant_alias: invoice.plant_alias,
                    doc_type:invoice.doc_type,
                    invoice_no:invoice.invoice_no,
                    invoice_date: invoice.invoice_date,
                    customer_name:invoice.customer_name,
                    project_name:invoice.project_name,
                    invoice_amt:  invoice.invoice_amt,
                    salesrep_name:invoice.salesrep_name,
                    einvoice_status:invoice.einvoice_status,
                    einvoice_irn:invoice.einvoice_irn,
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Sales Invoice',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(invoice => ({
                    plant_alias: invoice.plant_alias,
                    id: invoice.id,
                    invoice_amt:  invoice.invoice_amt,
                    invoice_no:invoice.invoice_no,
                    invoice_date: invoice.invoice_date,
                    invoice_time: invoice.invoice_time,
                    doc_type:invoice.doc_type,
                    order_no:invoice.order_no,
                    customer_name:invoice.customer_name,
                    salesrep_name:invoice.salesrep_name,
                    consignee_name:invoice.consignee_name,
                    project_name:invoice.project_name,
                    pan_no:invoice.pan_no,
                    gst_no: invoice.gst_no,
                    einvoice_status:invoice.einvoice_status,
                    einvoice_irn:invoice.einvoice_irn
            })),
            'SalesInvoice.pdf'
        );
    };

    const loadSalesInvoices = useCallback((config) => {
        if (!config) return;
        setIsLoading(true);
        getAllInvoices(cookies, buildSalesInvoiceQueryParams(config))
            .then(response => {
                const tableData = response.invoice_list.map(invoice => (
                {
                    plant_alias: invoice.plant?.alias_name ?? '',
                    id: invoice.id,
                    invoice_amt:  invoice.invoice_amt ?? '',
                    invoice_no:`${invoice.prefix ?? ''}${invoice.invoice_no ?? ''}`,
                    invoice_date: invoice.invoice_date ?? '',
                    invoice_time: invoice.invoice_time ?? '',
                    doc_type:'SALES',
                    order_no:`${invoice.sales_order?.prefix ?? ''}${invoice.sales_order?.order_no ?? ''}`,
                    customer_name:invoice.sales_order?.consignee?.customer?.name ?? '',
                    salesrep_name:invoice.sales_order?.consignee?.customer?.salesrep?.name ?? '',
                    consignee_name:invoice.sales_order?.consignee?.name ?? '',
                    project_name:invoice.sales_order?.consignee?.project_name ?? '',
                    pan_no:invoice.sales_order?.consignee?.customer?.pan_no ?? '',
                    gst_no: invoice.sales_order?.consignee?.customer?.gst_no ?? '',
                    einvoice_irn: invoice.einvoice_irn || '',
                    einvoice_status: invoice.einvoice_irn
                        ? 'Generated'
                        : invoice.einvoice_status === -1
                            ? 'Generation Failed'
                            : 'Not Generated',
                    remarks:invoice.remarks ?? '',
                    status:invoice.status? "Active":"Cancelled"
                }));
                setData({
                    records: tableData
                });
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
                displayError(error.response?.data ?? error.message, 'Failed to load Sales Invoice list');
            });
    }, [cookies]);

    const handleSettingsSaved = useCallback((config) => {
        loadSalesInvoices(config);
    }, [loadSalesInvoices]);

    useEffect(() => {
        getListViewSettings(cookies, 'sales_invoice')
            .then((response) => loadSalesInvoices(response.config || {}))
            .catch((error) => {
                setIsLoading(false);
                displayError(error.response?.data ?? error.message, 'Failed to load Sales Invoice settings');
            });
    }, [cookies, loadSalesInvoices]);
    
    return (
        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
                <ListFormPageHeader
                    module="ACCOUNTS"
                    title="List of Invoice"
                    viewKey="sales_invoice"
                    onSettingsSaved={handleSettingsSaved}
                    formLink="/SalesInvoice"
                    addNewLabel="New Tax Invoice"
                />
           
                <div className="container item-list-table-container">
                    <div className="table-responsive">
                        <ReactTableWrapper
                            title='List of Invoice'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditSalesPosting}
                            hideDelete={true}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                            onRowPrint={onPrintSalesPosting}
                            hidePrint ={false}
                        />
                    </div>
                </div> 
            </div>
            <button style={{position:"relative",right:"40px"}}className="btn btn-fill btn-primary float-end" type="button" onClick={() =>{navigate("/SalesInvoice")}}>Back</button>
        </div>
    );
}

export default SalesInvoiceTable;